import {
  cloneDeep, find, forEach, isEmpty
} from "lodash";

const initialState = {
  loadingProducts: false,
  total_pages: 0,
  products: []
};

const inventoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_INVENTORIES_REQUEST_START':
      return {
        ...state,
        loadingProducts: true
      };
    case 'GET_INVENTORIES_REQUEST_END':
      return {
        ...state,
        loadingProducts: false
      };
    case 'GET_INVENTORIES':
      let newProducts;
      if (action.canConcatProducts) {
        newProducts = cloneDeep(state.products).concat(action.data.products);
      } else {
        newProducts = action.data.products;
      }

      return {
        ...state,
        products: newProducts,
        total_pages: action.data.total_pages
      };
    default:
      return state;
  }
};

export default inventoriesReducer;
